// extracted by mini-css-extract-plugin
export default {"spinner-outer":"SpinnerOverlayView_spinner-outer__NTG6F"};